import { render, staticRenderFns } from "./ProductModalComponent.html?vue&type=template&id=309e2fec&scoped=true&"
import script from "./ProductModalComponent.js?vue&type=script&lang=js&"
export * from "./ProductModalComponent.js?vue&type=script&lang=js&"
import style0 from "./ProductModalComponent.scss?vue&type=style&index=0&id=309e2fec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309e2fec",
  null
  
)

export default component.exports